import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { signal } from 'cerebral/tags'

export default connect(
  {
    onNewValue: signal`selectr.onNewValue`,
    onDownKey: signal`selectr.onDownKey`,
    onUpKey: signal`selectr.onUpKey`,
    onBackSpace: signal`selectr.onBackSpace`,
    onLeftTag: signal`selectr.onLeftTag`,
    setOptionsClosed: signal`selectr.setOptionsClosed`,
    onTabKey: signal`selectr.onTabKey`
  },
  class KeyHandler extends Component {
    onKeyDown(e) {
      const {
        onNewValue,
        onDownKey,
        onUpKey,
        onBackSpace,
        onLeftTag,
        namespace,
        onTabKey
      } = this.props
      const value = e.target.value
      switch (e.keyCode) {
        case 37: // left
          if (value.length === 0) {
            onLeftTag({ namespace })
          }
          break
        case 9: // tab
          if (value.length > 0) {
            e.preventDefault()
            e.stopPropagation()
            onTabKey({ namespace })
          }
          break
        case 39: // right
          break
        case 8: // backspace
          if (value.length === 0) {
            onBackSpace({ namespace })
          }
          break
        case 13: // enter
          if (!value.length > 0) {
            return
          }
          onNewValue({ namespace, value })
          break
        case 38: // up
          onUpKey({ namespace })
          break
        case 40: // down
          onDownKey({ namespace })
          break
        default:
          return
      }
    }

    constructor(props) {
      super(props)
      this.hideSelect = this.hideSelect.bind(this)
    }

    hideSelect(e = false) {
      const target = e.currentTarget
      const { setOptionsClosed, namespace } = this.props
      setTimeout(() => {
        if (!e || !target.contains(document.activeElement)) {
          setOptionsClosed({ namespace, close: true })
        }
      }, 0)
    }

    render() {
      return (
        <div onBlur={this.hideSelect} onKeyDown={e => this.onKeyDown(e)}>
          {this.props.children}
        </div>
      )
    }
  }
)
